import { getStore } from '@store/storeUtils';
import { verticalScale } from '@utils/normalize';
import React, { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import { Dropdown } from 'react-native-element-dropdown';
import { logDropDownPressed } from './analyticsBPAccountSelector';
import { dropDownOnChange, dropDownRenderItem, dropDownRenderLeftIcon } from './bpReqAccSelectorUtils';
import styles from './styles';

interface PaymentMethod {
  id: string;
  name: string;
  label: string;
  value: string;
}

interface ProductConfig {
  transaction_category_id: string;
}

interface BPReqData {
  productCode: string;
}

interface Props {
  paymentMethods?: PaymentMethod[];
  setSelectedBPAccount?: (account: PaymentMethod) => void;
  bpReqData?: BPReqData;
  source?: string;
  productConfig?: ProductConfig;
}

function BPRequestAccountSelector(props: Props) {
  const { selectedBPAccount, employeeId, validatedReferralCode } = getStore();
  const { paymentMethods = [], setSelectedBPAccount, bpReqData, source, productConfig } = props;

  const [eligibleAccounts, setEligibleAccounts] = useState<PaymentMethod[]>(paymentMethods);
  const [selectedEligibleAccount, setSelectedEligibleAccount] = useState<PaymentMethod>(eligibleAccounts[0]);

  useEffect(() => {
    const enabledAccounts = paymentMethods;
    setEligibleAccounts(enabledAccounts);
    const matchedAccount = enabledAccounts.find(item => item.id === selectedBPAccount.id);
    if (matchedAccount) {
      setSelectedEligibleAccount(matchedAccount);
    }
  }, [paymentMethods, selectedBPAccount]);

  return (
    <Dropdown
      testID="dropDownAccounts"
      data={eligibleAccounts}
      value={selectedEligibleAccount}
      maxHeight={Platform.OS === 'web' ? undefined : verticalScale(150)}
      onFocus={() => {
        logDropDownPressed(source, employeeId, productConfig, bpReqData, validatedReferralCode);
      }}
      onChange={dropDownOnChange(
        setSelectedEligibleAccount,
        setSelectedBPAccount,
        employeeId,
        productConfig?.transaction_category_id,
        bpReqData?.productCode,
        source,
        bpReqData,
        validatedReferralCode,
      )}
      labelField="label"
      valueField="value"
      containerStyle={styles.dropDownContainerStyles}
      style={styles.dropDownStyles}
      renderLeftIcon={dropDownRenderLeftIcon(selectedEligibleAccount)}
      renderItem={dropDownRenderItem(selectedEligibleAccount)}
    />
  );
}

BPRequestAccountSelector.defaultProps = {
  paymentMethods: [{ name: '' }],
  setSelectedBPAccount: () => {},
  bpReqData: {
    productCode: '',
  },
  source: '',
  productConfig: {
    transaction_category_id: '',
  },
};

export default BPRequestAccountSelector;
